export default __webpack_public_path__ + "static/media/octus.75508544.obj";